import styled, { css } from 'styled-components';
import { fontUi, opticalCenter } from '../../theme/typography';

export const StyledContainer = styled.div`
  background-color: transparent;
  color: ${({ theme }) => theme.text};
  padding: 8px 4px 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const StyledTabs = styled.div`
  display: flex;
  gap: 4px;
  padding: 0 6px 6px;
`;

export const StyledTab = styled.button`
  ${fontUi};
  flex: 1;
  min-width: 0;
  padding: 7px 8px;
  border: 0;
  border-radius: 6px;
  background: ${({ $active, theme }) => ($active ? theme.text : theme.hover)};
  color: ${({ $active, theme }) => ($active ? theme.card : theme.textMuted)};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  cursor: pointer;
`;

export const StyledTaskItem = styled.button`
  ${fontUi};
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: ${({ $done, $locked }) => ($done || $locked ? 'default' : 'pointer')};
  &:disabled {
    cursor: default;
  }
`;

export const StyledTaskLeft = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

export const StyledCheckbox = styled.span`
  ${opticalCenter};
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 1.5px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.card};
  ${({ $done, theme }) =>
    $done &&
    css`
      background: ${theme.success};
      border-color: ${theme.success};
      &::after {
        content: '';
        width: 4px;
        height: 8px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg) translateY(-1px);
      }
    `};
`;

export const StyledTaskType = styled.span`
  ${fontUi};
  font-size: 14px;
  font-weight: 500;
  color: ${({ $muted, theme }) => ($muted ? theme.textFaint : theme.text)};
`;

export const StyledTaskArrow = styled.span`
  ${opticalCenter};
  flex-shrink: 0;
  color: ${({ theme }) => theme.textFaint};
  svg {
    display: block;
    width: 12px;
    height: 12px;
  }
`;

export const StyledTaskMeta = styled.span`
  ${fontUi};
  flex-shrink: 0;
  margin-left: auto;
  font-size: 12px;
  font-weight: 600;
  color: ${({ $muted, theme }) => ($muted ? theme.textFaint : theme.text)};
`;

export const StyledClaimButton = styled.button`
  ${fontUi};
  display: block;
  width: calc(100% - 20px);
  margin: auto 10px 4px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.button};
  background: ${({ theme }) => theme.button};
  color: ${({ theme }) => theme.buttonText};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    opacity: 0.45;
    cursor: default;
    border-color: ${({ theme }) => theme.border};
    background: ${({ theme }) => theme.hover};
    color: ${({ theme }) => theme.textFaint};
  }
`;

export const StyledEmpty = styled.p`
  ${fontUi};
  margin: 0;
  padding: 12px 10px;
  font-size: 13px;
  color: ${({ theme }) => theme.textFaint};
`;
